import { FirebaseError } from 'firebase/app';

/** User-facing copy for failed httpsCallable invocations. */
export function userMessageFromCallableError(err: unknown): string {
  if (err instanceof FirebaseError) {
    switch (err.code) {
      case 'functions/unavailable':
      case 'functions/deadline-exceeded':
        return 'Our service is busy. Please try again in a moment.';
      case 'functions/resource-exhausted':
        return 'Too many attempts. Please wait a few minutes and try again.';
      case 'functions/permission-denied':
        return 'Access was denied. Please refresh the page and try again.';
      case 'functions/unauthenticated':
        return 'Sign-in required for this action.';
      case 'functions/invalid-argument':
        return err.message || 'Please check your details and try again.';
      case 'functions/not-found':
        return 'Service is updating. Please try again shortly.';
      case 'functions/internal': {
        const m = (err.message || '').trim();
        if (m.length > 0 && !/^internal$/i.test(m)) {
          return m.length > 280 ? `${m.slice(0, 277)}…` : m;
        }
        return 'The deck service returned an error. Please try again in a moment.';
      }
      default:
        break;
    }
  }
  if (err instanceof Error) {
    const msg = (err.message || '').trim();
    if (/could not reach|network error|failed to fetch|load failed/i.test(msg)) {
      return 'Could not reach our servers. Check your connection and try again.';
    }
    if (msg.length > 0) {
      return msg.length > 280 ? `${msg.slice(0, 277)}…` : msg;
    }
  }
  const fallback = typeof err === 'string' ? err.trim() : '';
  if (fallback.length > 0) {
    return fallback.length > 280 ? `${fallback.slice(0, 277)}…` : fallback;
  }
  return 'Something went wrong. Please try again or contact compliance@kyrocapital.in.';
}
